import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
const StyledQRCodeImpl = lazy(() => import("./StyledQRCodeImpl"));
const StyledQRCode = (props) => {
    const size = props.size ?? 140;
    return (_jsx(Suspense, { fallback: _jsx("div", { style: { width: size, height: size }, "aria-hidden": "true" }), children: _jsx(StyledQRCodeImpl, { ...props }) }));
};
export default StyledQRCode;
